import TextContentBlock from 'models/common/content/block/TextContentBlock';

export default class TextContentBlockService {
	toModel(block) {
		return new TextContentBlock(block);
	}
}
